import { AlertVariant } from "@next-platform/client-common-spicy-ui";
import { IConversationMessage } from "@next-platform/client-common-core";

import { Conversation } from "@/types";

export enum SocketDataType {
  AUDIO_URL = "audio_url",
  CHUNK = "chunk",
  DONE = "done",
}

export interface CustomAudioBufferSourceNode extends AudioBufferSourceNode {
  isEnded?: boolean;
}

export type GenerationOptions = {
  type?: string;
  regenerate?: boolean;
  autopilot?: boolean;
  continue_chat?: boolean;
  content?: string;
  image_prompt?: string;
  image_key?: string;
  resubmit?: boolean;
  abortSignal?: AbortSignal | null;
  subCharacterId?: string | null;
};

export type SendFailureResult = {
  sendFailed: true;
  errorCode: string | null;
};

export type GenerateResult = string | void | IConversationMessage | SendFailureResult | null;

export type ImageGenerationPayload = {
  alt_message_id?: string;
  prev_id?: string;
  conversation_id?: string | null;
  character_id?: string;
  image_prompt?: string;
  model_style?: string;
  nsfw_mode?: boolean;
  legacy_mode?: boolean;
  lora_scale?: number;
  user_prompt_suffix?: string;
  user_negative_prompt?: string;
  hasNewChatInfra?: boolean;
  user_persona_id?: string | null;
  include_user_persona_image?: boolean;
};

export interface IRequestErrorHandler {
  isError: boolean;
  errorMessage: string;
  errorTitle?: string;
  actionHandler: () => void;
  variant: AlertVariant;
  actionTitle: string | undefined;
}

export interface ILoadMessageAfterGenerate {
  conversationIdFromMsgRes: string;
  generatedMessage?: IConversationMessage;
  autopilot?: boolean;
}

export interface IHandleLoadMessages {
  res: Conversation;
  last_id?: string | null;
  generatedMessage?: IConversationMessage;
}

export interface ILoadMessages {
  limit?: number;
  last_id?: string | null;
  updatedConversationId?: string;
  generatedMessage?: IConversationMessage;
}
